import http from '@/requests/http'

class Schedule {
  static all (params) {
    return http.post('schedules/index', params)
  }
  static viewPushNotification (params) {
    return http.post('schedules/push-notification/view', params)
  }
  static storePushNotification (params) {
    return http.post('schedules/push-notification/store', params)
  }
  static async updatePushNotification (data) {
    return http.post('schedules/push-notification/update', data)
  }
  static destroyPushNotification (params) {
    return http.post('schedules/push-notification/destroy', params)
  }
  static viewMemo (params) {
    return http.post('schedules/memo/view', params)
  }
  static storeMemo (params) {
    return http.post('schedules/memo/store', params)
  }
  static async updateMemo (data) {
    return http.post('schedules/memo/update', data)
  }
  static destroyMemo (params) {
    return http.post('schedules/memo/destroy', params)
  }
  static async show (data) {
    return http.post('schedules/show', data)
  }
}

export default Schedule
